export default "__VITE_ASSET__D2dR2SL7__"